const Eyes = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="59"
    height="44"
    viewBox="0 0 59 44"
    fill="none"
  >
    <g clipPath="url(#clip0_12971_13913)">
      <path
        d="M14.2208 43.4922C21.5969 43.4922 27.5764 33.8697 27.5764 21.9998C27.5764 10.1298 21.5969 0.507324 14.2208 0.507324C6.84472 0.507324 0.865234 10.1298 0.865234 21.9998C0.865234 33.8697 6.84472 43.4922 14.2208 43.4922Z"
        fill="url(#paint0_linear_12971_13913)"
      />
      <path
        d="M14.2152 42.3093C20.9766 42.3093 26.4577 33.1859 26.4577 21.9317C26.4577 10.6775 20.9766 1.5542 14.2152 1.5542C7.45382 1.5542 1.97266 10.6775 1.97266 21.9317C1.97266 33.1859 7.45382 42.3093 14.2152 42.3093Z"
        fill="url(#paint1_linear_12971_13913)"
      />
      <path
        d="M14.2208 39.7458C20.1763 39.7458 25.0042 31.5136 25.0042 21.3587C25.0042 11.2038 20.1763 2.97168 14.2208 2.97168C8.26536 2.97168 3.4375 11.2038 3.4375 21.3587C3.4375 31.5136 8.26536 39.7458 14.2208 39.7458Z"
        fill="url(#paint2_linear_12971_13913)"
      />
      <path
        d="M27.012 21.3589C26.7052 21.3589 26.458 21.6075 26.4582 21.9133C26.4582 21.9194 26.4582 21.9257 26.4582 21.9318C26.4582 33.1859 20.9769 42.3093 14.2156 42.3093C7.45437 42.3093 1.9731 33.1859 1.9731 21.9318C1.9731 21.9257 1.9731 21.9194 1.9731 21.9133C1.9731 21.6075 1.72608 21.3589 1.41926 21.3589C1.11417 21.3589 0.86619 21.6049 0.865234 21.9089C0.865234 21.9392 0.865234 21.9695 0.865234 21.9997C0.865234 33.8696 6.84475 43.4922 14.2208 43.4922C21.5968 43.4922 27.5764 33.8696 27.5764 21.9997C27.5764 21.9695 27.5764 21.9392 27.5764 21.9089C27.5754 21.6049 27.3274 21.3589 27.0223 21.3589H27.0122H27.012Z"
        fill="#818181"
      />
      <path
        d="M44.8224 43.4922C52.1984 43.4922 58.1779 33.8697 58.1779 21.9998C58.1779 10.1298 52.1984 0.507324 44.8224 0.507324C37.4463 0.507324 31.4668 10.1298 31.4668 21.9998C31.4668 33.8697 37.4463 43.4922 44.8224 43.4922Z"
        fill="url(#paint3_linear_12971_13913)"
      />
      <path
        d="M44.8187 42.3093C51.5801 42.3093 57.0612 33.1859 57.0612 21.9317C57.0612 10.6775 51.5801 1.5542 44.8187 1.5542C38.0573 1.5542 32.5762 10.6775 32.5762 21.9317C32.5762 33.1859 38.0573 42.3093 44.8187 42.3093Z"
        fill="url(#paint4_linear_12971_13913)"
      />
      <path
        d="M44.8829 39.7458C50.8384 39.7458 55.6663 31.5136 55.6663 21.3587C55.6663 11.2038 50.8384 2.97168 44.8829 2.97168C38.9275 2.97168 34.0996 11.2038 34.0996 21.3587C34.0996 31.5136 38.9275 39.7458 44.8829 39.7458Z"
        fill="url(#paint5_linear_12971_13913)"
      />
      <path
        d="M57.6136 21.3589C57.3068 21.3589 57.0595 21.6075 57.0597 21.9133C57.0597 21.9194 57.0597 21.9257 57.0597 21.9318C57.0597 33.1859 51.5785 42.3093 44.8172 42.3093C38.0559 42.3093 32.5747 33.1859 32.5747 21.9318C32.5747 21.9257 32.5747 21.9194 32.5747 21.9133C32.5747 21.6075 32.3276 21.3589 32.0208 21.3589C31.7157 21.3589 31.4678 21.6049 31.4668 21.9089C31.4668 21.9392 31.4668 21.9695 31.4668 21.9997C31.4668 33.8696 37.4463 43.4922 44.8224 43.4922C52.1984 43.4922 58.1779 33.8696 58.1779 21.9997C58.1779 21.9695 58.1779 21.9392 58.1779 21.9089C58.177 21.6049 57.929 21.3589 57.6239 21.3589H57.6138H57.6136Z"
        fill="#818181"
      />
      <path
        d="M9.36953 31.4088C13.4547 31.4088 16.7664 28.1086 16.7664 24.0374C16.7664 19.9663 13.4547 16.666 9.36953 16.666C5.28435 16.666 1.97266 19.9663 1.97266 24.0374C1.97266 28.1086 5.28435 31.4088 9.36953 31.4088Z"
        fill="url(#paint6_linear_12971_13913)"
      />
      <path
        d="M9.36957 30.8406C13.1398 30.8406 16.1962 27.7947 16.1962 24.0375C16.1962 20.2802 13.1398 17.2344 9.36957 17.2344C5.59934 17.2344 2.54297 20.2802 2.54297 24.0375C2.54297 27.7947 5.59934 30.8406 9.36957 30.8406Z"
        fill="url(#paint7_linear_12971_13913)"
      />
      <path
        d="M12.5941 27.2519C14.3755 25.4767 14.3755 22.5985 12.5941 20.8233C10.8128 19.0481 7.92469 19.0481 6.14336 20.8233C4.36202 22.5985 4.36202 25.4767 6.14336 27.2519C7.92469 29.0271 10.8128 29.0271 12.5941 27.2519Z"
        fill="#200302"
      />
      <path
        d="M14.0136 27.3127L13.9725 27.2792C13.5379 26.9249 12.9105 26.9561 12.5026 27.3405C11.6855 28.1106 10.5828 28.583 9.36927 28.583C9.04602 28.583 8.7308 28.5494 8.42665 28.4857C7.91484 28.3785 7.39616 28.6342 7.18142 29.1094L7.15888 29.1591C6.87059 29.7969 7.24275 30.5413 7.92879 30.6883C8.39322 30.7878 8.87503 30.8402 9.36927 30.8402C11.1939 30.8402 12.8511 30.1266 14.0757 28.9645C14.5577 28.5072 14.5288 27.7323 14.0138 27.3123L14.0136 27.3127Z"
        fill="#E5AD30"
      />
      <path
        d="M8.77933 21.5249C9.56569 20.7412 9.56569 19.4707 8.77933 18.687C7.99296 17.9034 6.71802 17.9034 5.93165 18.687C5.14529 19.4707 5.14529 20.7412 5.93165 21.5249C6.71802 22.3086 7.99296 22.3086 8.77933 21.5249Z"
        fill="#F4F4F4"
      />
      <path
        d="M39.9711 31.4088C44.0563 31.4088 47.368 28.1086 47.368 24.0374C47.368 19.9663 44.0563 16.666 39.9711 16.666C35.8859 16.666 32.5742 19.9663 32.5742 24.0374C32.5742 28.1086 35.8859 31.4088 39.9711 31.4088Z"
        fill="url(#paint8_linear_12971_13913)"
      />
      <path
        d="M39.9711 30.8406C43.7414 30.8406 46.7977 27.7947 46.7977 24.0375C46.7977 20.2802 43.7414 17.2344 39.9711 17.2344C36.2009 17.2344 33.1445 20.2802 33.1445 24.0375C33.1445 27.7947 36.2009 30.8406 39.9711 30.8406Z"
        fill="url(#paint9_linear_12971_13913)"
      />
      <path
        d="M43.1976 27.2519C44.979 25.4767 44.979 22.5985 43.1976 20.8233C41.4163 19.0481 38.5282 19.0481 36.7469 20.8233C34.9655 22.5985 34.9655 25.4767 36.7469 27.2519C38.5282 29.0271 41.4163 29.0271 43.1976 27.2519Z"
        fill="#200302"
      />
      <path
        d="M44.6171 27.3127L44.576 27.2792C44.1414 26.9249 43.514 26.9561 43.1061 27.3405C42.289 28.1106 41.1863 28.583 39.9728 28.583C39.6495 28.583 39.3343 28.5494 39.0302 28.4857C38.5182 28.3785 37.9997 28.6342 37.7849 29.1094L37.7624 29.1591C37.4741 29.7969 37.8463 30.5413 38.5323 30.6883C38.9967 30.7878 39.4786 30.8402 39.9728 30.8402C41.7975 30.8402 43.4546 30.1266 44.6792 28.9645C45.1612 28.5072 45.1323 27.7323 44.6173 27.3123L44.6171 27.3127Z"
        fill="#E5AD30"
      />
      <path
        d="M39.3828 21.5254C40.1692 20.7417 40.1692 19.4712 39.3828 18.6875C38.5965 17.9038 37.3215 17.9038 36.5352 18.6875C35.7488 19.4712 35.7488 20.7417 36.5352 21.5254C37.3215 22.309 38.5965 22.309 39.3828 21.5254Z"
        fill="#F4F4F4"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_12971_13913"
        x1="14.2208"
        y1="43.4924"
        x2="14.2208"
        y2="0.507324"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9B9B9B" />
        <stop offset="1" stopColor="#9B9B9B" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_12971_13913"
        x1="14.2152"
        y1="42.3093"
        x2="14.2152"
        y2="1.55439"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B7B7B7" />
        <stop offset="1" stopColor="#D8D8D8" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_12971_13913"
        x1="14.2208"
        y1="39.7458"
        x2="14.2208"
        y2="2.97187"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D0D0D0" />
        <stop offset="0.695" stopColor="#FCFCFC" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_12971_13913"
        x1="44.8224"
        y1="0.507324"
        x2="44.8224"
        y2="0.507324"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9B9B9B" />
        <stop offset="1" stopColor="#9B9B9B" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_12971_13913"
        x1="44.8187"
        y1="0.507259"
        x2="44.8187"
        y2="1.55439"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B7B7B7" />
        <stop offset="1" stopColor="#D8D8D8" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_12971_13913"
        x1="44.8829"
        y1="39.7458"
        x2="44.8829"
        y2="2.97187"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D0D0D0" />
        <stop offset="0.695" stopColor="#FCFCFC" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_12971_13913"
        x1="2.96265"
        y1="20.3512"
        x2="15.7543"
        y2="27.7621"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4F1C01" />
        <stop offset="1" stopColor="#B07810" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_12971_13913"
        x1="3.45654"
        y1="20.6355"
        x2="15.2622"
        y2="27.475"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#582A00" />
        <stop offset="1" stopColor="#D08F15" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_12971_13913"
        x1="33.5642"
        y1="20.3512"
        x2="46.356"
        y2="27.7621"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4F1C01" />
        <stop offset="1" stopColor="#B07810" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_12971_13913"
        x1="34.0581"
        y1="20.6355"
        x2="45.8637"
        y2="27.475"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#582A00" />
        <stop offset="1" stopColor="#D08F15" />
      </linearGradient>
      <clipPath id="clip0_12971_13913">
        <rect
          width="57.3134"
          height="42.9851"
          fill="white"
          transform="translate(0.865234 0.507324)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default Eyes;
